import React, { useContext } from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

import ContentfulDataContext from "../context/contentful-data"

const Interview = props => {
  const { allContentfulInterview } = useContext(ContentfulDataContext)

  if (!props.slug) {
    return null
  }

  const interviews = allContentfulInterview.edges.filter(
    ({ node: int }) => int.slug === props.slug
  )

  if (!interviews || !interviews.length) {
    return null
  }

  const interview = interviews[0].node

  const Header = ({ id, children }) => (
    <>
      {props.headerType === "h3" ? (
        <h3 id={id} className="interview-header">
          {children}
        </h3>
      ) : (
        <h2 id={id} className="interview-header">
          {children}
        </h2>
      )}
    </>
  )

  return (
    <>
      <Header id={interview.slug}>
        <Link to={`/athletes/${interview.slug}`}>{interview.header}</Link>
      </Header>
      <Link to={`/athletes/${interview.slug}`}>
        <Img
          fluid={interview.backgroundImage.fluid}
          alt={interview.backgroundImage.title}
        />
      </Link>
      {interview.excerpt ? <p>{interview.excerpt.excerpt}</p> : ""}
    </>
  )
}

export default Interview
